module.exports = __webpack_public_path__ + "img/_0.8a4ea567.png";